<template>
	<div id="info">
  		<mt-header fixed :title="$t(title)">
          	<mt-button icon="back" slot="left" onclick="window.history.go(-1)"></mt-button>
        </mt-header>
        <iframe v-bind:src="url" frameborder="0" scrolling="yes" width="100%" id="bdIframe" ref="iframe"></iframe>
	</div>
</template>
<script>
	import { Swipe, SwipeItem} from 'mint-ui';
	import { httpGetLists } from "@/api/wealth";
	export default{
		data:function() {  
		    return {  
                title:'',
                url:'',
		    }  
	    }, 
        activated(){
            this.title = this.$route.query.title;
            this.url = this.$route.query.url;
        },
	    methods:{
		}
	}
</script>
<style scoped>
#info{width:100%;height:100%;overflow: hidden;position: fixed;background:#f6f6f6;}
/*顶部*/
.header{width:100%;height:200px;position: relative;}
.mint-header{background: #ffffff;color:#212529;}
.header .bg{width:100%;height:100%;}

</style>